import React from 'react';
import ReactDOM from 'react-dom';
import 'react-toastify/dist/ReactToastify.css';; // toastify configuration
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-select-search/style.css' //react-select-search configuration
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
// import 'sweetalert2/src/sweetalert2.scss'
// import registerServiceWorker from './registerServiceWorker';
import { ErrorBoundary } from 'react-error-boundary';
import axios from 'axios';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { unregister } from './registerServiceWorker';
import './assets/base.css';
import MainLayout from './layouts/MainLayout';
import configureStore from './config/configureStore';

import { AbilityContext } from './config/Can';
import Error from './Error';
import ability from './config/ability';
import { config } from './config';
import './styles.css'
const toastStyle = {
  color: 'white', // Set text color to white
  // Add any other style properties you want to customize globally
};

const store = configureStore();
const rootElement = document.getElementById('root');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
    },
  },
});

const renderApp = Component => {
  ReactDOM.render(
    <ErrorBoundary FallbackComponent={Error}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <AbilityContext.Provider value={ability}>
            <BrowserRouter>
              <Component />
              <ToastContainer toastStyle={toastStyle} />
            </BrowserRouter>
          </AbilityContext.Provider>
        </QueryClientProvider>
      </Provider>
    </ErrorBoundary>,
    rootElement
  );
};

renderApp(MainLayout);

if (module.hot) {
  module.hot.accept('./layouts/MainLayout', () => {
    // eslint-disable-next-line global-require
    const NextApp = require('./layouts/MainLayout').default;
    renderApp(NextApp);
  });
}
unregister();

// registerServiceWorker();
